export default __webpack_public_path__ + "static/media/S1xCLUE3.7dd0fdab.jpg";